import Image from "next/image";
import { useWindowSize } from "@uidotdev/usehooks";
import React, { useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

export default function VideoWithTwoTitles() {
  const windowSize = useWindowSize();
  const [videoModalImpactIntiative, setvideoModalImpactIntiative] =
    useState(false);

  const [videoModalSupporters, setvideoModalSupporters] = useState(false);

  const handleVideo = () => {
    var iframes = document.querySelectorAll("iframe");
    const elementsArray = Array.from(iframes);
    for (var i = 0; i < elementsArray.length; i++) {
      const src = elementsArray[i].src;
      if (src && src.includes("youtube.com")) {
        // Replace "autoplay=1" with "autoplay=0" to stop the video
        elementsArray[i].src = src.replace("autoplay=1", "autoplay=0");
      }
    }
  };
  return (
    <div className="py-10">
      <div className="lg:flex lg:flex-nowrap justify-between benifit">
        {/* <div className="lg:w-[43%] h-40  mb-12 p-5 rounded-2.5xl border transition-shadow hover:shadow-xl dark:border-jacarta-50 dark:bg-jacarta-700">        
        </div>
        <div className="lg:w-[43%] h-40  mb-12 p-5 rounded-2.5xl border transition-shadow hover:shadow-xl dark:border-jacarta-50 dark:bg-jacarta-700">        
        </div> */}
        <div className="lg:w-[43%] relative">
          <figure className="hidden lg:flex items-center justify-center">
            <Image
              width={420}
              height={420}
              src="/images/impactoverse-for/impact_Intiative.png"
              alt="benifit"
              className="rounded-full border border-jacarta-100 p-14 object-contain"
            />

            <button
              onClick={() => setvideoModalImpactIntiative(true)}
              className="js-video-modal-trigger absolute top-48 left-1/2 flex h-16 w-16 -translate-y-1/2 -translate-x-1/2 items-center justify-center rounded-full border-2 border-white transition-transform will-change-transform hover:scale-90"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                className="h-8 w-8 fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M19.376 12.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832z" />
              </svg>
            </button>
          </figure>
          <div
            className={
              videoModalImpactIntiative
                ? "modal lightbox fade show block"
                : "modal lightbox fade"
            }
          >
            <div className="modal-dialog modal-dialog-centered modal-xl w-full">
              <div className="modal-content border-0 bg-transparent">
                <div className="modal-body p-0 relative">
                  <button
                    onClick={() => (
                      handleVideo(), setvideoModalImpactIntiative(false)
                    )}
                    type="button"
                    className="btn-close position-absolute top-0 end-0 p-3 z-10"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 16 16"
                      fill="#fff"
                      className="h-6 w-6"
                    >
                      <path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path>
                    </svg>
                  </button>
                  <div
                    id="lightboxCarousel-d7ewe4ig"
                    className="lightbox-carousel carousel"
                  >
                    <div className="carousel-inner">
                      <div className="carousel-item active">
                        <div className="position-absolute top-50 start-50 translate-middle text-white">
                          <div className="spinner-border" role="status"></div>
                        </div>
                        <div className="ratio ratio-16x9">
                          <iframe
                            id="video"
                            src="https://www.youtube.com/embed/RI_Vppbqozk"
                            title="Impact Intiative - Supporter for Impact"
                            allow="accelerometer clipboard-write encrypted-media gyroscope picture-in-picture autoplay"
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[43%]">
          <button
            className="group relative flex w-full border-b border-jacarta-100 text-left dark:border-jacarta-600"
            type="button"
            onClick={() => {
              if (windowSize?.width <= 1024) {
                setvideoModalImpactIntiative(true);
              }
            }}
          >
            <div className=" mb-12 p-5 rounded-2.5xl border transition-shadow hover:shadow-xl dark:border-jacarta-50 dark:bg-jacarta-700">
              <span className="mb-2 block font-display text-xl font-medium text-jacarta-700 group-hover:text-accent dark:text-white  transition-colors text-left uppercase">
                Our mission
              </span>
              <div className="nav-link-content">
                <p className="text-jacarta-500 dark:text-jacarta-300 text-left">
                  Our mission is to pioneer innovative uses of technology that
                  educates, inspires, and empowers global citizens to
                  collectively address pressing environmental and social
                  challenges.
                </p>
              </div>
            </div>
          </button>
          {/* <div className=" mb-12 p-5 rounded-2.5xl border transition-shadow hover:shadow-xl dark:border-jacarta-50 dark:bg-jacarta-700">
            Our vision is to create an ecosystem that enables an engaged
              community of changemakers that transcends boundaries, generations,
              and cultures - one that leverages the power of technology and
              creativity not just for innovative collaboration and experiences,
              but also to drive awareness, compassion, and measurable impact. 
            </div> */}
          <button
            className="group relative flex w-full border-b border-jacarta-100 text-left dark:border-jacarta-600"
            type="button"
            onClick={() => {
              if (windowSize?.width <= 1024) {
                setvideoModalImpactIntiative(true);
              }
            }}
          >
            <div className=" mb-12 p-5 rounded-2.5xl border transition-shadow hover:shadow-xl dark:border-jacarta-50 dark:bg-jacarta-700">
              <span className="mb-2 block font-display text-xl font-medium text-jacarta-700 group-hover:text-accent dark:text-white  transition-colors text-left uppercase">
                Our vision
              </span>
              <p className="text-jacarta-500 dark:text-jacarta-300 text-left">
                Our vision is to create an ecosystem that enables an engaged
                community of changemakers that transcends boundaries,
                generations, and cultures - one that leverages the power of
                technology and creativity not just for innovative collaboration
                and experiences, but also to drive awareness, compassion, and
                measurable impact.
              </p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
